export const APIs = {
  baseUrl: `${process.env.REACT_APP_BASE_URL}`,
};

export const DB_Service = {
  name: 'ProjectDB',
};
export const API_Service = {
  Url: `${APIs.baseUrl}/server/rest/services/${DB_Service.name}/FeatureServer`,
  // WebMapUrl: "22beb40ec7ef44059d7e89726de4b9cf",
  View_Url: `${APIs.baseUrl}/server/rest/services/ViewService/MapServer`,
};

export const ProjectRoutes = {
  projectPostQuery: `${APIs.baseUrl}/server/rest/services/${DB_Service.name}/FeatureServer/0/query`,
};

// export const ServiceIndex = {
//   ServiceArea: 5,
//   Projects: 0,
//   ProjectAssetTypes: 3,
//   ProjectAssetGroup: 4,
//   ProjectRoles: 6,
//   ProjectAssignments: 7,
//   ProjectUnitAssignments: 8,
//   ProjectSuffix: 9,
// };

export const ServiceIndex = {
  ServiceArea: 0,
  Projects: 1,
  ProjectAssetTypes: 2,
  ProjectAssetGroup: 3,
  ProjectRoles: 4,
  ProjectAssignments: 5,
  ProjectUnitAssignments: 6,
  ProjectSuffix: 7,
  EnterpriseUsers: 8,
  Workflow: 9,
  IntelliFiberRoles: 10,
  IntelliFiberUserRoles: 11,
  IntelliFiberRolePermissions: 12,
  IntelliFiberPermissions: 13,
  Intelli_Fiber_ProjectUserRoles: 14,
  Intelli_Fiber_Phase: 15,
  Intelli_Fiber_ProjectScope: 16,
  Intelli_Fiber_ProjectScopeHistory: 17,
  Intelli_Fiber_PhaseScopeHistory: 18,
  Intelli_Fiber_MonthlyStatus: 19,
  Intelli_Fiber_Risks: 20,
  Intelli_Fiber_StatusRisks: 21,
  Intelli_Fiber_ProjectItem: 22,
};

export const ViewIndex = {
  ProjectServiceArea: 0,
  ServiceAreaProject: 1,
  AssetMaster: 2,
  ProjectUnitAssignments: 3,
  IntelliFiberUserRoles: 4,
  ProjectUserRoles: 5,
  RolePermissions: 6,
  ProjectScopeView: 7,
  ProjectScopeHistoryView: 8,
  ProjectMonthlyStatusView: 9,
};

// export const ServiceIndexName = {
//   ServiceArea: "ServiceArea",
//   Projects: "Projects",
//   ProjectAssetTypes: "ProjectAssetTypes",
//   ProjectAssetGroup: "ProjectAssetGroup",
//   ProjectRoles: "ProjectRoles",
//   ProjectAssignments: "ProjectAssignments",
//   ProjectUnitAssignments: "ProjectUnitAssignments",
//   ProjectSuffix: "ProjectSuffix",
// };
